/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type BuildingAccessControlOrganisationUserStatus =
    (typeof BuildingAccessControlOrganisationUserStatus)[keyof typeof BuildingAccessControlOrganisationUserStatus];

export const BuildingAccessControlOrganisationUserStatus = {
    Active: 1,
    Inactive: 2,
    Pending: 3,
} as const;
